import axios from "axios";

const ApiAxiosInstance = axios.create({
    baseURL: "/api",
    timeout: 10000,
    headers: {
        post: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        get: {
            "Content-Type": "application/json",
        },
    },
});

export default ApiAxiosInstance;
